import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";

const firebaseConfig = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyD_DUMMY_KEY_FOR_DEV_EMULATOR_0001", // 39 chars standard length dummy
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "dummy-domain",
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "sewa-crm-gcp", // Must match project ID in docker-compose
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "dummy-bucket",
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "dummy-sender",
    appId: import.meta.env.VITE_FIREBASE_APP_ID || "dummy-app-id",
    databaseId: import.meta.env.VITE_FIRESTORE_DATABASE_ID || "(default)"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app, firebaseConfig.databaseId);

// Connect to Emulators only if explicitly requested
if (import.meta.env.VITE_USE_EMULATOR === "true") {
    console.log("📍 Connecting to Firebase Emulators...");
    connectAuthEmulator(auth, "http://localhost:9099");
    connectFirestoreEmulator(db, "localhost", 8080);
}

